import jwt_decode from 'jwt-decode';

/**
 * Decodifica un token JWT y retorna el payload.
 * @param {string} token - Token JWT a decodificar.
 * @returns {Object|undefined} - Objeto decodificado o undefined si ocurre un error.
 */
export const decodeToken = (token) => {
	try {
		const decodedToken = jwt_decode(token);
		return decodedToken;
	} catch (error) {
		console.error('Error al decodificar el token:', error);
	}
};

/**
 * Codifica un objeto de usuario en un token JWT.
 * @param {Object} user - Datos del usuario a codificar.
 * @returns {string} - Token JWT generado.
 */
export const encodeToken = (user) => {
	const sing = require('jwt-encode');
	const token = sing(user, '9ed7811a6ab9f6581bf1985a222a9d5e', { expiresIn: 86400 });
	return token;
};